import $api from "../../../../../services/axiosService";
import { setUpcomingLeavesAction } from "../upcomingLeaves.action";

export const getUpcomingLeavesThunkAction = () => async (dispatch) => {
    try {
        const currentYear = new Date().getFullYear();
        const response = await $api(`v1/p/po/leaves/${currentYear}`);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const allItems = response.data.flatMap((type) => {
            if (!Array.isArray(type.items)) return [];
            return type.items
                .filter((item) => item.from && new Date(item.from) >= today)
                .map((item) => ({ ...item, typeName: type.typeName, typeId: type.typeId }));
        });

        allItems.sort((a, b) => new Date(a.from) - new Date(b.from));

        const leaves = allItems.map((item, i) => ({ ...item, isNearest: i === 0 }));

        dispatch(setUpcomingLeavesAction(leaves));
    } catch (e) {
        // silent
    }
};